import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-forgotpassword-confirmation',
  templateUrl: './forgotpassword-confirmation.component.html',
  styleUrls: ['./forgotpassword-confirmation.component.scss']
})
export class ForgotpasswordConfirmationComponent implements OnInit {

  email;

  constructor(
    private toastr: ToastrService,
    private authService: AuthService

  ) {
    this.email = localStorage.getItem('forgot_password_email')
  }

  ngOnInit() {
  }

  resendLink() {
    this.authService.resendForgotPasswordMail(this.email).subscribe(
      res => {
        this.toastr.success('An Email with Instructions has been sent again to your email', 'Success')
      },
      err => {
        this.toastr.error('There is some error sending an email to you', 'Error');
      }
    )
  }

}
